import {NgModule} from '@angular/core';
import {RouterModule, Routes, UrlSerializer} from '@angular/router';
import {getInstitutionId} from './constants/constant';
import {environment} from '@env/environment';
import {LowerCaseUrlSerializer} from '@core/util-services/utils.service';
import {ErrorPageComponent} from '@content/partials/snippets/error-page/error-page.component';

const routes: Routes = [
    {
        path: '',
        loadChildren: () => {
            const institution = getInstitutionId(environment.env || 'local');
            if (institution.flow && institution.flow === '2') {
                return import('@flow2/flow2.module').then(m => m.Flow2Module);
            }
            return import('@flow1/flow1.module').then(m => m.Flow1Module);
        }
    },
    {
        path: 'error/:type',
        component: ErrorPageComponent
    },
    {
        path: '**',
        redirectTo: '404',
        pathMatch: 'full'
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes)
    ],
    exports: [RouterModule],
    providers: [
        {
            provide: UrlSerializer,
            useClass: LowerCaseUrlSerializer
        }
    ]
})
export class AppRoutingModule {
}
